import React from 'react';

export const Pianificazione = React.lazy(() => import('../Pianificazione/AddPianificazione/AddPianificazione') );
export const ProfiliOrariFSE = React.lazy( () => import('../ProfiliOrari/ProfiliOrariFSE/ProfiliOrariFSE') );
export const ProfiliOrariFSEContainer = React.lazy(() => import('../ProfiliOrari/ProfiliOrariFSE/profilazione/ProfiliOrariFSEContainer'));
export const Calendario = React.lazy(() => import('../Calendario/Calendario'));
export const ProfiliOrariSCR = React.lazy(() => import('../ProfiliOrari/ProfiliOrariSCR/riepilogo/ProfiliOrariSCR'));
export const UpdateChoice = React.lazy(() => import('../Pianificazione/UpdPianificazione/UpdateChoice'));
export const ProfiloSCRContainer = React.lazy(() => import('../ProfiliOrari/ProfiliOrariSCR/profilazione/ProfiloSCRContainer'));
export const Presenze = React.lazy(() => import('../Presenze/Presenze'));
export const MonitoraggioValidazioniContainer = React.lazy(() => import ('../MonitoraggioValidazioni/MonitoraggioValidazioniContainer'));
export const SchedaCorso = React.lazy(() => import('../SchedaCorso/SchedaCorso'));

export const Giustificativo = React.lazy(() => import('../Presenze/Giustificativo/Giustificativi'));
export const DettaglioIndividuoContainer = React.lazy(() => import('../ProfiliOrari/Dettaglio_profili/DettaglioIndividuoContainer'));
export const RegistroIndividui = React.lazy(() => import('../Registro/RegistroIndividuo/RegistroIndividui'));
export const RegistroMeseSCR = React.lazy(() => import('../Registro/RegistroSCR/RegistroMeseSCR'));
export const RegistroDettaglio = React.lazy(() => import('../Registro/RegistroDettaglio/RegistroDettaglio'));
export const TimbraturaManuale = React.lazy(() => import('../Presenze/Timbrature/TimbraturaManuale/TimbraturaManuale'));
export const Castelletto = React.lazy(() => import('../Castelletto/Castelletto'));
export const ValidazioneCorsoContainer = React.lazy(() => import('../ValidazioneCorso/validazioneCorsoContainer'));








